import type { PenAnchorPoint } from '@/lib/elements/types/pen-anchor-point'

export function deepClonePoints(pts: PenAnchorPoint[]): PenAnchorPoint[] {
  return pts.map((p) => ({
    ...p,
    handleIn: p.handleIn ? { ...p.handleIn } : null,
    handleOut: p.handleOut ? { ...p.handleOut } : null,
  }))
}

/** Every anchor and handle moved back by (`shiftX`, `shiftY`) — i.e. `p - shift`. */
export function shiftPointsBack(
  pts: PenAnchorPoint[],
  shiftX: number,
  shiftY: number
): PenAnchorPoint[] {
  return pts.map((p) => ({
    ...p,
    x: p.x - shiftX,
    y: p.y - shiftY,
    handleIn: p.handleIn ? { x: p.handleIn.x - shiftX, y: p.handleIn.y - shiftY } : null,
    handleOut: p.handleOut ? { x: p.handleOut.x - shiftX, y: p.handleOut.y - shiftY } : null,
  }))
}
